import { createContext } from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect("https://apnamandal-admin.vercel.app");
export const SocketContext = createContext();
